function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_235",
  "data-name": "Path 235",
  d: "M462.46,247.629H429.794a.809.809,0,0,1-.65-.333c-2.018-2.777-7.525-4.025-8.2-4.166a3.074,3.074,0,0,1-2.991-3.13,3.131,3.131,0,0,1,3.151-3.022h50.036A3.131,3.131,0,0,1,474.3,240a3.085,3.085,0,0,1-2.991,3.13c-.671.146-6.178,1.394-8.2,4.166a.809.809,0,0,1-.65.333m-32.27-1.607h31.875c2.668-3.2,8.732-4.43,9-4.483a.825.825,0,0,1,.157-.015,1.466,1.466,0,0,0,1.472-1.5,1.516,1.516,0,0,0-1.545-1.441H421.109a1.516,1.516,0,0,0-1.545,1.441,1.466,1.466,0,0,0,1.472,1.5.841.841,0,0,1,.157.015c.265.053,6.329,1.28,9,4.483",
  transform: "translate(-406.407 -195.712)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_266",
  "data-name": "Rectangle 266",
  width: 56.827,
  height: 10.901,
  transform: "translate(11.073 41.023)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_236",
  "data-name": "Path 236",
  d: "M418.4,235.446a3.042,3.042,0,0,1-.442-1.644,3.135,3.135,0,0,1,3.152-3.022h50.035A3.134,3.134,0,0,1,474.3,233.8a3.025,3.025,0,0,1-.442,1.644l-1.373-.827a1.5,1.5,0,0,0,.209-.786,1.521,1.521,0,0,0-1.545-1.446H421.11a1.52,1.52,0,0,0-1.545,1.446,1.486,1.486,0,0,0,.208.786Z",
  transform: "translate(-406.407 -195.702)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_267",
  "data-name": "Rectangle 267",
  width: 56.827,
  height: 6.656,
  transform: "translate(11.073 34.367)",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_237",
  "data-name": "Path 237",
  d: "M418.4,229.253a3.056,3.056,0,0,1-.442-1.644,3.135,3.135,0,0,1,3.152-3.022h50.035a3.134,3.134,0,0,1,3.151,3.022,3.05,3.05,0,0,1-.442,1.644l-1.373-.832a1.472,1.472,0,0,0,.209-.786,1.516,1.516,0,0,0-1.545-1.441H421.11a1.515,1.515,0,0,0-1.545,1.441,1.462,1.462,0,0,0,.208.786Z",
  transform: "translate(-406.407 -195.693)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_268",
  "data-name": "Rectangle 268",
  width: 56.827,
  height: 6.657,
  transform: "translate(11.073 27.71)",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_238",
  "data-name": "Path 238",
  d: "M418.4,223.055a3.042,3.042,0,0,1-.442-1.644,3.131,3.131,0,0,1,3.152-3.017h50.035a3.13,3.13,0,0,1,3.151,3.017,3.025,3.025,0,0,1-.442,1.644l-1.373-.827a1.481,1.481,0,0,0,.209-.786A1.521,1.521,0,0,0,471.145,220H421.11a1.52,1.52,0,0,0-1.545,1.446,1.472,1.472,0,0,0,.208.786Z",
  transform: "translate(-406.407 -195.685)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_269",
  "data-name": "Rectangle 269",
  width: 56.827,
  height: 5.325,
  transform: "translate(11.073 22.384)",
  fill: "none"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_239",
  "data-name": "Path 239",
  d: "M418.4,216.863a3.056,3.056,0,0,1-.442-1.644,3.135,3.135,0,0,1,3.152-3.022h50.035a3.134,3.134,0,0,1,3.151,3.022,3.039,3.039,0,0,1-.442,1.644l-1.373-.832a1.472,1.472,0,0,0,.209-.786,1.52,1.52,0,0,0-1.545-1.441H421.11a1.52,1.52,0,0,0-1.545,1.446,1.486,1.486,0,0,0,.208.786Z",
  transform: "translate(-406.407 -195.675)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_270",
  "data-name": "Rectangle 270",
  width: 56.827,
  height: 6.657,
  transform: "translate(11.073 15.728)",
  fill: "none"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_240",
  "data-name": "Path 240",
  d: "M415.393,241.265a25.959,25.959,0,1,1,40.049-31.526l-1.425.739a24.356,24.356,0,1,0-37.574,29.57Z",
  transform: "translate(-406.39 -195.65)",
  fill: "#707070"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_271",
  "data-name": "Rectangle 271",
  width: 49.682,
  height: 46.348,
  transform: "translate(0.001)",
  fill: "none"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_241",
  "data-name": "Path 241",
  d: "M411.758,221.651h-1.607a22.184,22.184,0,0,1,.234-3.224l1.587.229a21.211,21.211,0,0,0-.214,3",
  transform: "translate(-406.395 -195.685)",
  fill: "#707070"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_242",
  "data-name": "Path 242",
  d: "M412.644,215.632l-1.534-.463a22.423,22.423,0,0,1,7.909-11.29,22.012,22.012,0,0,1,13.34-4.462v1.608a20.769,20.769,0,0,0-19.716,14.608",
  transform: "translate(-406.397 -195.656)",
  fill: "#707070"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_243",
  "data-name": "Path 243",
  d: "M424.306,210.77l-.957-1.29a15.134,15.134,0,0,1,18.061,0l-.962,1.29a13.523,13.523,0,0,0-16.143,0",
  transform: "translate(-406.415 -195.666)",
  fill: "#707070"
});

function SvgDishwasher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_140_1",
    "data-name": "Component 140 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.899,
    height: 51.924,
    viewBox: "0 0 67.899 51.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.74390c4089e3508033f1f6a729231aca.svg";
export { ForwardRef as ReactComponent };